var $8aad853c076397e7$exports = {};
let $8aad853c076397e7$var$lastScrollTop = 0;
const $8aad853c076397e7$var$header = document.querySelector('header');
window.addEventListener('scroll', ()=>{
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop < 20) // находимся в начале страницы
    $8aad853c076397e7$var$header.classList.remove('header-hide');
    else if (scrollTop > $8aad853c076397e7$var$lastScrollTop) // скроллим вниз
    $8aad853c076397e7$var$header.classList.add('header-hide');
    else // скроллим вверх
    $8aad853c076397e7$var$header.classList.remove('header-hide');
    $8aad853c076397e7$var$lastScrollTop = scrollTop;
});


//# sourceMappingURL=en-run.8e8acbc3.js.map
